export default "__VITE_ASSET__DzHQeLJ9__"